module.exports = __webpack_public_path__ + "img/gallery15.f1c3f072.png";